import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IManagementContractsModalData } from 'src/app/models/dialog';

import { DetailLotEnum, ILot } from 'src/app/models/generic';

@Component({
  selector: 'app-generate-lots-dialog',
  templateUrl: './generate-lots-dialog.component.html',
  styleUrls: ['./generate-lots-dialog.component.scss']
})
export class GenerateLotsDialogComponent {
  @Input() lot!: ILot;
  @Input() typeLot: DetailLotEnum = this.data.template.typeLot!;
  DetailLotEnum = DetailLotEnum;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IManagementContractsModalData
  ) {}
}
